import { useSelector } from "react-redux";
import { Navigate, useLocation } from "react-router-dom";

export const HomeRedirect = () => {
const location = useLocation();
  console.log(" i am in  Mounted");

  const roleData = useSelector((state) => state.role.roles);
 
 console.log("roleData",roleData);

if (roleData === undefined) {
  return null; // loading
}
   if (!roleData) {
  return <Navigate to="/dashboard" replace />;
}


  if (roleData?.isDashboard) {
    return <Navigate to="/dashboard" replace />;
  }

  if (roleData?.waitListManagement?.isRead) {
    return <Navigate to="/waitlist" replace />;
  }

  if (roleData?.misManagement?.isRead) {
    return <Navigate to="/user-list" replace />;
  }

  if (roleData?.userManagement?.isRead) {
    return <Navigate to="/new-request" replace />;
  }
   
   if (roleData?.deleteAccountManagement?.isRead) {
    return <Navigate to="/deleted-users" replace />;
  }
   if (roleData?.adsManagement?.isRead) {
    return <Navigate to="/listings" replace />;
  }
    if (roleData?.safetyCheckManagement?.isRead) {
    return <Navigate to="/safetychecks" replace />;
  }
   if (roleData?.safetyCheckManagement?.isRead) {
    return <Navigate to="/safetychecks" replace />;
  }
  if (roleData?.blockedUserManagement?.isRead) {
    return <Navigate to="/blocked-chat" replace />;
  }
   if (roleData?.reportManagement?.isRead) {
    return <Navigate to="/reported-chat" replace />;
  }
  if (roleData?.contactUsManagement?.isRead) {
    return <Navigate to="/contact-us" replace />;
  }
    if (roleData?.notificationManagement?.isRead) {
    return <Navigate to="/notification" replace />;
  }
  
  return <Navigate to="/denied" replace />;
};